import { createAsyncThunk, createSlice,type PayloadAction } from '@reduxjs/toolkit';
import { ntxAPI } from '../../../API/axiosNeatex';
import type { APIResponse } from '../../Shared/shared';

interface AttendanceAdjustmentModels {
  id: string;
  personId: string;
  personName: string;
  personName2: string;
  employeeNumber: string;
  startDateTime: string;
  endDateTime: string;
  attendenceAdjustmentType: string;
  reason: string;
  isAme: false;
}

export const addAttendanceAdjustment = createAsyncThunk(
  'AttendanceAdjustment/addAttendanceAdjustment',
  async (item: any, { rejectWithValue }) => {
    try {
      const { data } = await ntxAPI.post('RAQ/AddAttendanceAdjustment', item);
      return data;
    } catch (error: any) {
      return rejectWithValue(error.message);
    }
  }
);

export const updateAttendenceAdjustment = createAsyncThunk(
  'AttendanceAdjustment/updateAttendenceAdjustment',
  async (item: any, { rejectWithValue }) => {
    try {
      const { data } = await ntxAPI.post('RAQ/UpdateAttendenceAdjustment', item);
      return data;
    } catch (error: any) {
      return rejectWithValue(error.message);
    }
  }
);

export const getAttendenceAdjustmentByPersonId = createAsyncThunk(
  'AttendanceAdjustment/getAttendenceAdjustmentByPersonId',
  async ({ id }: { id?: string }, { rejectWithValue }) => {
    try {
      const params = id ? { personId: id } : {};
      const { data } = await ntxAPI.get(`RAQ/GetAttendenceAdjustmentByPersonId`, { params });
      // const { data } = await ntxAPI.get(`RAQ/GetAttendenceAdjustmentByPersonId?personId=${id}`);
      if (data.succeeded === true) {
        return data.data;
      } else {
        return [];
      }
    } catch (error: any) {
      return rejectWithValue(error.message);
    }
  }
);

export const getAttendenceAdjustmentById = createAsyncThunk(
  'AttendanceAdjustment/getAttendenceAdjustmentById',
  async (id: string, { rejectWithValue }) => {
    try {
      const { data } = await ntxAPI.get(`RAQ/GetAttendenceAdjustmentById?id=${id}`);
      if (data.succeeded === true) {
        return data.data;
      } else {
        return [];
      }
    } catch (error: any) {
      return rejectWithValue(error.message);
    }
  }
);

export const deletedAttendanceAdjustment = createAsyncThunk(
  'AttendanceAdjustment/deletedAttendanceAdjustment',
  async (id: string, { rejectWithValue }) => {
    try {
      const { data } = await ntxAPI.post<APIResponse<Boolean>>(
        `RAQ/DeletedAttendanceAdjustment?Id=${id}`
      );
      return data;
    } catch (error: any) {
      return rejectWithValue(error.message);
    }
  }
);

const initialState: {
  AttendenceAdjustmentByPersonId: AttendanceAdjustmentModels[];
  loading: boolean;
  error: any | null;
  //~~~~~~~~~
  AttendenceAdjustmentById: AttendanceAdjustmentModels;
  loadingById: boolean;
  errorById: any | null;
} = {
  AttendenceAdjustmentByPersonId: [],
  loading: false,
  error: null,
  AttendenceAdjustmentById: {} as AttendanceAdjustmentModels,
  loadingById: false,
  errorById: null,
};

const AttendanceAdjustmentSlice = createSlice({
  name: 'AttendanceAdjustment',
  initialState,
  reducers: {},
  extraReducers(builder) {
    builder

      .addCase(getAttendenceAdjustmentByPersonId.pending, (state, action) => {
        state.loading = true;
      })
      .addCase(
        getAttendenceAdjustmentByPersonId.fulfilled,
        (state, action: PayloadAction<AttendanceAdjustmentModels[]>) => {
          state.loading = false;
          state.AttendenceAdjustmentByPersonId = action.payload;
        }
      )
      .addCase(getAttendenceAdjustmentByPersonId.rejected, (state, action: PayloadAction<any>) => {
        state.loading = false;
        state.error = action.payload;
      })

      //~~~~~~~~~~~~~~~~~~~~~~~~~~~~
      .addCase(getAttendenceAdjustmentById.pending, (state, action) => {
        state.loadingById = true;
        state.errorById = null;
      })
      .addCase(
        getAttendenceAdjustmentById.fulfilled,
        (state, action: PayloadAction<AttendanceAdjustmentModels>) => {
          state.loadingById = false;
          state.AttendenceAdjustmentById = action.payload;
        }
      )
      .addCase(getAttendenceAdjustmentById.rejected, (state, action: PayloadAction<any>) => {
        state.loadingById = false;
        state.errorById = action.payload;
      });
  },
});

export default AttendanceAdjustmentSlice.reducer;
